import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Divider,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import AppConfig from "appConfig";
import usePageTitle from "app/pageTitle";
import MDInput from "theme/components/MDInput";

function CallCentersPage() {
  const pageTitle = "Call Centers";
  usePageTitle(pageTitle);

  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [callCenters, setCallCenters] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("agents/call_centers.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCallCenters(result.data.data.centers);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  const [search, setSearch] = useState("");

  const filteredCenters = callCenters.filter((center) => {
    const value = search.toLowerCase();

    return (
      center.title?.toLowerCase().includes(value) ||
      center.account.name?.toLowerCase().includes(value)
    );
  });
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={1} mb={5}>
        <MDBox mb={3}>
          <Card
            sx={{
              overflow: "hidden",
            }}
          >
            <MDBox
              p={2.5}
              sx={{
                background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
              }}
            >
              <MDBox
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                mb={2.5}
              >
                <MDBox display="flex" alignItems="center">
                  <MDBox
                    sx={{
                      width: "46px",
                      height: "46px",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#e8f5e9",
                    }}
                  >
                    <Icon
                      sx={{
                        fontSize: "25px !important",
                      }}
                    >
                      phone_sip
                    </Icon>
                  </MDBox>

                  <MDBox ml={1.5}>
                    <MDTypography variant="h6" fontWeight="medium">
                      Call Centers
                    </MDTypography>

                    <MDTypography variant="body2" color="text" fontSize={11}>
                      Your assigned call centers
                    </MDTypography>
                  </MDBox>
                </MDBox>

                <MDBox
                  sx={{
                    minWidth: "36px",
                    height: "36px",
                    px: 1,
                    borderRadius: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f0f2f5",
                  }}
                >
                  <MDTypography variant="caption" fontWeight="medium">
                    {callCenters.length}
                  </MDTypography>
                </MDBox>
              </MDBox>

              <MDInput
                fullWidth
                label="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </MDBox>
          </Card>
        </MDBox>
        {/* <MDBox mb={3}>
          <Card>
            <MDBox p={2}>
              <MDBox
                display="flex"
                justifyContent="space-between"
                px={1}
                mb={2}
              >
                <MDBox pt={0.5}>
                  <Icon>support_agent</Icon>
                </MDBox>
                <MDBox>
                  <MDTypography variant="caption" fontWeight="regular">
                    Call Centers
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox my={2} align="center">
                <MDInput
                  fullWidth
                  label="Search..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </MDBox>
            </MDBox>
          </Card>
        </MDBox> */}
        <MDBox mt={0}>
          {callCenters.length > 0 ? (
            <MDBox>
              {filteredCenters.map((callCenter) => (
                <MDBox
                  mb={3}
                  onClick={() => {
                    navigate(`/call-centers/${callCenter.reference}`);
                  }}
                >
                  <Card>
                    <MDBox p={1.5}>
                      <MDBox display="flex" justifyContent="space-between">
                        <MDBox>
                          <MDTypography variant="caption" fontWeight="regular">
                            {callCenter.account.name}
                          </MDTypography>
                        </MDBox>
                        <MDBox pt={1}>
                          <Icon>east</Icon>
                        </MDBox>
                      </MDBox>
                      <Divider />
                      <MDBox display="flex" justifyContent="space-between">
                        <MDBox>
                          <MDTypography variant="h6" fontSize={16}>
                            {callCenter.title}
                          </MDTypography>
                        </MDBox>
                        <MDBox>
                          <img
                            src={`${AppConfig.api_media_url}${callCenter.account.icon}`}
                            width="24px"
                          />
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              ))}
            </MDBox>
          ) : (
            <Card>
              <MDBox align="center" p={2}>
                <MDTypography fontSize={48}>
                  <Icon>warning</Icon>
                </MDTypography>
                <MDTypography variant="body2">
                  You have not been added to any call centers yet.
                </MDTypography>
              </MDBox>
            </Card>
          )}
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CallCentersPage;
